import {Lead, Slot, Text, Trail} from '@logistics-frontend/blocks'
import {Image} from '@logistics-frontend/blocks/image'
import {spacing} from '@logistics-frontend/blocks/theme/theme'
import {tag2url} from '@logistics-frontend/utils'
import React from 'react'

import {renderWidget} from '..'
import type {HeaderWidgetConfig} from '../types'

export const HeaderWidget = ({image, title, trail}: HeaderWidgetConfig): React.ReactElement => (
  <Slot pr="xs" size="l">
    {image && (
      <Lead>
        <Image alt="" height={spacing(5)} src={tag2url(image.image_tag)} />
      </Lead>
    )}
    <Text>{title.items.map(renderWidget)}</Text>
    {trail && <Trail>{renderWidget(trail)}</Trail>}
  </Slot>
)
